export default{
  carousel:[
    {
      id: 0,
      title: '',
      text: 'Poświęcenie ryngrafu w Skorbucianach 13.05.2012',
      img: "/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_3.jpg"
    },
    {
      id: 1,
      title: '',
      text: 'Poświęcenie ryngrafu w Koloni Wileńskiej 14.05.2012',
      img: "/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_4.jpg"
    },
    {
      id: 2,
      title: '',
      text: 'Poświęcenie ryngrafu w Koleśnikach 15.05.2012r.',
      img: "/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_5.jpg"
    },
    {
      id: 3,
      title: '',
      text: 'Kolonia Wileńska',
      img: "/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_6.jpg"
    },
    {
      id: 4,
      title: '',
      text: 'Koleśniki',
      img: "/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_7.jpg"
    },
    {
      id: 5,
      title: '',
      text: 'Skorbuciany',
      img: "/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_8.jpg"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/aktualnosci/zawiesz_posw_votum.js